import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box, Container, Typography, Grid, Stack, Divider, IconButton, Tooltip,
} from '@mui/material';
import {
  Facebook, Twitter, YouTube, LinkedIn, Pinterest, Instagram, Chat,
} from '@mui/icons-material';
import { C } from './theme';

const socialIcons = [
  { icon: <Facebook fontSize="small" />, label: 'Facebook' },
  { icon: <Twitter fontSize="small" />, label: 'Twitter' },
  { icon: <YouTube fontSize="small" />, label: 'YouTube' },
  { icon: <LinkedIn fontSize="small" />, label: 'LinkedIn' },
  { icon: <Pinterest fontSize="small" />, label: 'Pinterest' },
  { icon: <Instagram fontSize="small" />, label: 'Instagram' },
];

const VpsFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (target) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const el = document.getElementById(target);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box component="footer" sx={{ background: '#0F172A', color: '#FFFFFF', pt: 8, pb: 4 }}>
      <Container maxWidth="xl">

        {/* Brand Header */}
        <Box sx={{ mb: 5 }}>
          <Box sx={{ mb: 2 }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                background: '#FFFFFF',
                borderRadius: '8px',
                px: 1.5,
                py: 0.75,
              }}
            >
              <Box
                component="img"
                src="/assets/logo.png"
                alt="Premium Backlink Services"
                sx={{
                  height: { xs: 38, md: 44 },
                  width: 'auto',
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            </Box>
          </Box>
          <Typography sx={{ color: '#94A3B8', fontSize: '0.86rem', maxWidth: 380, lineHeight: 1.6 }}>
            Manually placed, high-authority white-hat backlinks that move rankings —
            without the risk. Secured payments via Razorpay Payment Gateway.
          </Typography>
        </Box>

        {/* Footer Link Columns (MUI v6 Grid size) */}
        <Grid container spacing={4} sx={{ mb: 6 }}>
          <Grid size={{ xs: 6, sm: 4, md: 2.4 }}>
            <Typography sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: '0.88rem', mb: 2 }}>
              Link Packages
            </Typography>
            <Stack spacing={1}>
              {['Starter Backlinks', 'Growth Backlinks', 'Authority Backlinks', 'Guest Posting', 'Niche Edits', 'Custom Campaigns'].map((l) => (
                <Typography key={l} component="span" onClick={() => handleNavClick('pricing')}
                  sx={{ color: '#94A3B8', fontSize: '0.82rem', cursor: 'pointer', '&:hover': { color: '#FFFFFF' } }}>
                  {l}
                </Typography>
              ))}
            </Stack>
          </Grid>

          <Grid size={{ xs: 6, sm: 4, md: 2.4 }}>
            <Typography sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: '0.88rem', mb: 2 }}>
              Solutions
            </Typography>
            <Stack spacing={1}>
              {['Local Businesses', 'Ecommerce Stores', 'SEO Agencies (White-Label)', 'SaaS & Startups', 'Affiliate Sites'].map((l) => (
                <Typography key={l} component="span" onClick={() => handleNavClick('features')}
                  sx={{ color: '#94A3B8', fontSize: '0.82rem', cursor: 'pointer', '&:hover': { color: '#FFFFFF' } }}>
                  {l}
                </Typography>
              ))}
            </Stack>
          </Grid>

          <Grid size={{ xs: 6, sm: 4, md: 2.4 }}>
            <Typography sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: '0.88rem', mb: 2 }}>
              Resources
            </Typography>
            <Stack spacing={1}>
              {['Affiliate Program', 'Agency Partner Program', 'Link Building Guide', 'Sample SEO Report'].map((l) => (
                <Typography key={l} component="span" onClick={() => handleNavClick('report')}
                  sx={{ color: '#94A3B8', fontSize: '0.82rem', cursor: 'pointer', '&:hover': { color: '#FFFFFF' } }}>
                  {l}
                </Typography>
              ))}
            </Stack>
          </Grid>

          <Grid size={{ xs: 6, sm: 4, md: 2.4 }}>
            <Typography sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: '0.88rem', mb: 2 }}>
              Support
            </Typography>
            <Stack spacing={1}>
              {['Knowledge Base', 'Contact Support', 'Link Removal Policy', 'Report Abuse'].map((l) => (
                <Typography key={l} component="span" onClick={() => handleNavClick('faq')}
                  sx={{ color: '#94A3B8', fontSize: '0.82rem', cursor: 'pointer', '&:hover': { color: '#FFFFFF' } }}>
                  {l}
                </Typography>
              ))}
            </Stack>
          </Grid>

          <Grid size={{ xs: 6, sm: 4, md: 2.4 }}>
            <Typography sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: '0.88rem', mb: 2 }}>
              Legal & Company
            </Typography>
            <Stack spacing={1}>
              <Typography component="span" onClick={() => navigate('/privacy-policy')}
                sx={{ color: '#94A3B8', fontSize: '0.82rem', cursor: 'pointer', '&:hover': { color: '#FFFFFF' } }}>
                Privacy Policy
              </Typography>
              <Typography component="span" onClick={() => navigate('/terms-and-conditions')}
                sx={{ color: '#94A3B8', fontSize: '0.82rem', cursor: 'pointer', '&:hover': { color: '#FFFFFF' } }}>
                Terms & Conditions
              </Typography>
              <Typography component="span" onClick={() => navigate('/refund-policy')}
                sx={{ color: '#94A3B8', fontSize: '0.82rem', cursor: 'pointer', '&:hover': { color: '#FFFFFF' } }}>
                Refund Policy
              </Typography>
              <Typography component="span" onClick={() => navigate('/checkout')}
                sx={{ color: '#94A3B8', fontSize: '0.82rem', cursor: 'pointer', '&:hover': { color: '#FFFFFF' } }}>
                Order Now
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: '#334155', mb: 4 }} />

        {/* Bottom Row */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography sx={{ color: '#94A3B8', fontSize: '0.82rem' }}>
            © {new Date().getFullYear()} Premium Backlink Services. All Rights Reserved.
          </Typography>

          <Stack direction="row" spacing={1}>
            {socialIcons.map((s) => (
              <Tooltip key={s.label} title={s.label}>
                <IconButton size="small" sx={{ color: '#94A3B8', '&:hover': { color: '#FFFFFF', background: '#1E293B' } }}>
                  {s.icon}
                </IconButton>
              </Tooltip>
            ))}
          </Stack>
        </Box>

      </Container>

      {/* Floating Chat */}
      <Box sx={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
        width: 52, height: 52, borderRadius: '50%', background: C.primary,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer', boxShadow: '0 4px 16px rgba(109,40,217,0.4)',
        '&:hover': { background: C.primaryHover, transform: 'scale(1.05)' },
        transition: 'all 0.2s',
      }}>
        <Chat sx={{ color: '#FFFFFF', fontSize: 22 }} />
      </Box>
    </Box>
  );
};

export default VpsFooter;
